module.exports = __webpack_public_path__ + "img/fantour.0b9c8a42.png";